/**
 * Module dependencies.
 */

import { advisorMarketTypes } from 'src/types/markets';
import {
  chemicalTypes,
  refillableOptions
} from 'src/core/content-config/model-ranges';

import { cylinderTypes } from 'src/types/technologies';
import { waterCapacityGasContentOptions } from './steps-options';

/**
 * Export `orderedAdvisorMarketTypes`.
 */

export const orderedAdvisorMarketTypes = [
  advisorMarketTypes.lpg,
  advisorMarketTypes.refrigerants,
  advisorMarketTypes.packagedChemicals,
  advisorMarketTypes.helium,
  advisorMarketTypes.scba
];

/**
 * Export `orderedCylinderTypes`.
 */

export const orderedCylinderTypes = [
  cylinderTypes.traditional,
  cylinderTypes.lightweight
];

/**
 * Export `orderedChemicalTypes`.
 */

export const orderedChemicalTypes = [
  chemicalTypes.airGases,
  chemicalTypes.fireSuppression,
  chemicalTypes.acsep
];

/**
 * Export `orderedRefillableOptions`.
 */

export const orderedRefillableOptions = [
  refillableOptions.refillable,
  refillableOptions.nonRefillable
];

/**
 * Export `orderedWaterCapacityGasContentOptions`.
 */

export const orderedWaterCapacityGasContentOptions = [
  waterCapacityGasContentOptions.waterCapacity,
  waterCapacityGasContentOptions.gasContent
];
